import { makeStyles } from '@material-ui/core/styles';

const useStyles = (disabled:boolean) => makeStyles((theme) => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    opacity: disabled ? 0.5 : 1,
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
}));

interface Props {
  children: any,
  disabled?: boolean,
  id?: string,
  onClick?: () => void,
  style?: React.CSSProperties,
}

const TextLink = (props: Props) => {
  const {
    children, disabled, id, onClick, style,
  } = props;
  const classes = useStyles(!!disabled)();

  const onClickHandler = () => {
    if (!onClick) return;
    onClick();
  };
  return (
    <span
      id={id}
      className={classes.link}
      onClick={onClickHandler}
      style={style}>
      {children}
    </span>
  );
};

export default TextLink;
